import React from 'react';
import {connect} from "react-redux";
import {sortBy} from "lodash";
import * as DOMPurify from 'dompurify';
import formatters from "../../../utils/forms/formatters";
import PPAChart from '../charts/ppaChart'
import BaseModal from "../../theme/modals/BaseModal";

export class NoteSection extends React.Component {

    static defaultProps = {
        notes: [],
    }

    constructor(props) {
        super(props);
        this.state = {
            open: this.props.isOpenOnMount,
            isHovered: false,
            chartModalData: null,
        }
    }

    render() {
        let notes = this.props.notes || [];
        notes = sortBy(notes, ['order', 'title'])

        let rows =  notes.map(note => {
            return (
                <tr key={note.title}>
                    <td
                        className="has-text-grey is-size-7"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.title) }}
                    />
                    <td
                        className="is-size-7 has-text-weight-semibold"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.note) }}
                    />
                </tr>
            )
        })

        return (
            <div className={`${this.state.open ?  'mt-3 mb-5': 'my-3'}`}>
                {this.props.title &&
                    <div className={`is-flex justify-space-between is-align-items-center has-icons-and-text-aligned is-clickable ${(this.state.open || this.state.isHovered) ? 'has-text-black-bis' : 'has-text-grey'}`}
                            onClick={() => {this.setState({open: !this.state.open})}}
                            onMouseEnter={() => this.setState({isHovered: true})}
                            onMouseLeave={() => this.setState({isHovered: false})}
                     >
                    <p className={`is-size-5 `}>{this.props.title}</p>
                    <i className={`fa ${this.state.open ? 'fa-chevron-down' : 'fa-chevron-left'} mt-2 is-size-5`} />

                </div>

                }

                <div className="table-container" style={this.state.open ? {height: "unset"} : {height: 0} }>
                    {this.props.children}
                    <table className="table is-fullwidth">
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}


class LoanEstimateCard extends React.Component {

    static defaultProps = {
        estimate: {
            attributes: [],
            project: {}
        },
        onApply: () => {},
        onShare: () => {},
        onAmortization: () => {},
        showApply: true
    }

    constructor(props) {
        super(props);
        this.state = {
            chartModalData: null,
        }
    }

    getAttributeHeaders = () => {
        const type = this.props.estimate?.product?.type

        if (type == 'PPA') {
            return (
                <thead>
                    <tr>
                        <th>Term (Yrs)</th>
                        <th>Annual Riser</th>
                        <th>Payment (Month)</th>
                        <th>Cost/kWh</th>
                        <th>Riser Chart</th>
                    </tr>
                </thead>
            )
        } 
            return (
            <thead>
                <tr>
                    <th>Term (Yrs)</th>
                    <th>Rate</th>
                    {type === 'PACE PPA' && <th>Annual Riser</th>}
                    {this.optionNeedsCapI() && <th>Capital Interest</th>}
                    <th># of paymts/yr</th>
                    <th>Per Paymt</th>
                    <th>Annual Paymt</th>
                    {type === 'PACE PPA' && <th>Cost/kWh</th>}
                    <th> </th>
                    <th>Amortization</th>

                </tr>
            </thead>
            )
        
    }

    getAttributeRows = () => {
        let rows = [];

        let type = this.props.estimate?.product?.type

        this.props.estimate.attributes
            .sort((a,b) => a.term > b.term ? 1 : -1)
            .forEach(d => {
            let annual_payments = d.schedule.filter(p => p.year === 1).length;
            // let annual_cost = d.schedule
            //     .filter(p => p.year === 1).map(p => p.payment_w_fees)
            //     .reduce((r,p) => r + p, 0)
            let p1 = d.schedule[0]
            let annual_cost = p1.payment_w_fees * annual_payments

            if (type === 'PPA') {
                rows.push(
                    <tr>
                        <td>{d.term}</td>
                        <td>{(d.annual_riser || 0)}%</td>
                        <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(p1.payment_w_fees)}</td>
                        <td className="has-text-weight-semibold">${d.cost_per_kwh}</td>
                        {(d.annual_riser || 0) > 0 ?
                            <td onClick={() => this.handleChartOpen(d)} className="cursor-is-pointer">
                                <i className="fas fa-chart-area"/>
                            </td> :
                            <td/>
                        }
                    </tr>
                )
            } else {
                rows.push(
                    <tr>
                        <td>{d.term}</td>
                        <td>{d.rate}%</td>
                        {type === 'PACE PPA' && <td>{d.annual_riser}%</td>}
                        {this.optionNeedsCapI() && <td>{formatters.USDCurrency.formatter(d.capitalized_interest)}</td>}
                        <td>{annual_payments}</td>
                        <td>{formatters.USDCurrency.formatter(p1.payment_w_fees)}</td>
                        <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(annual_cost)}</td>
                        {type === 'PACE PPA' && <td className="has-text-weight-semibold">${d.cost_per_kwh}</td>}
                        <td>{d.other_info ? (
                            <span className="icon has-text-info tooltip">
                                <i className="fas fa-info-circle"/>
                                <span className="tooltiptext">{d.other_info}</span>
                            </span>
                        ) : ''}
                        </td>
                        <td onClick={() => this.props.onAmortization(d.id)}>
                            <span className="icon has-text-info">
                                <i className="fas fa-list-ol"/>
                                {/* <span>Table</span> */}
                            </span>
                        </td>

                    </tr>
                )
            }
        })

        return rows

    }


    renderNoteTable(notes) {
        notes = notes || []
        notes = sortBy(notes, note => note.title)

        let rows =  notes.map(note => {
            return (
                <tr>
                    <td className="has-text-grey is-size-7">
                        {note.title}
                    </td>
                    <td className="is-size-7 has-text-weight-semibold">
                        {note.note}
                    </td>
                </tr>
            )
        })


        return (
            <div className="table-container">
                <table className="table">
                    <tbody>
                    {rows}
                    </tbody>
                </table>
            </div>
        )
    }

    getTitle() {
        if (this.props.title) {
            return this.props.title
        } if (this.props.showType) {
            return this.props.estimate?.product?.type
        } 
            return 'Option ' + this.props.index
        
    }


    optionNeedsCapI = () => {
        if (!this.props.estimate) return
        return this.props.estimate.attributes.some(d => d.capitalized_interest)
    }


    handleChartOpen = (attribute) => {
         let data = attribute.schedule
         this.setState({chartModalData: data})
    }

    handleChartClose = () => {
         this.setState( {chartModalData: null})
    }


    getClosingCostsList = () => {
        const fees_list = this.props.estimate?.one_time_fees_list || []

        if (!fees_list.length) return <></>

        let notes = fees_list.map(fee => (
            {
                title: fee.name,
                note: formatters.USDCurrency.formatter(fee.amount),
            }
        ));

        const total_costs = fees_list.reduce((r,d) => r + d.amount, 0)
        let title = `Closing Costs (Capitalized, Included in Monthly Payments): ${formatters.USDCurrency.formatter(total_costs)}`

        title = (
            <>
                <div>Closing Costs: {formatters.USDCurrency.formatter(total_costs)}</div>
                <div className="is-size-7 is-italic is-light mt-3">Capitalized/Included in Monthly Payments</div>
            </>
        )

        return (
            <NoteSection title={title} notes={notes} isOpenOnMount/>
        )
    }

    getRequiredDocsList = () => {
        const docs_list = this.props.estimate.required_docs || []
        if (!docs_list.length) return <></>

        const list_as_string = docs_list.reduce((r,d,i,a) => {
            r += '' + d.name;
            if (i < a.length - 1) {
                r += ', '
            }
            return r;
        }, '')

        return (
            <NoteSection title="Documents Required to Apply" >
                <p className="is-size-7 mt-2">{list_as_string}</p>
            </NoteSection>
        )
    }




    render () {

        let type = this.props.estimate?.product?.type

        if (!type) return <></>
        return (
            <div className="card loan-estimate-card mb-6">
                {this.props.header}
                <div className="card-content">
                    <div className="content">
                        <div className="level mb-4 no-print">
                            <div className="level-left">
                                <div className="level-item">
                                    <div className="title is-size-4 has-text-primary">
                                        {this.getTitle()}
                                    </div>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    {!!this.props.hasPriviledges && <button
                                        className="button is-primary mr-3"
                                        onClick={() => this.props.onShare()}
                                    > 
                                        Share
                                    </button>}
                                    {this.props.showApply && <button
                                        className="button is-link"
                                        onClick={() => this.props.onApply()}
                                    >
                                        Apply for this product
                                    </button>}
                                </div>
                            </div>
                        </div>

                        <div className="table-container mb-6">
                            <table className="table is-striped">
                                {this.getAttributeHeaders()}
                                <tbody>
                                {this.getAttributeRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>


                    {this.getClosingCostsList()}
                    {this.getRequiredDocsList()}

                    {!!(Object.keys(this.props.estimate?.admin_info || {})).length && !!this.props.is_admin &&
                        <NoteSection title="Admin Info"
                                     notes={Object.keys(this.props.estimate?.admin_info).map(key => ({title: key, note: this.props.estimate.admin_info[key]}))}
                                     isOpenOnMount={false}
                        />
                    }

                    <NoteSection title="Notes about this option" notes={this.props.estimate?.notes.sort((a,b) => a?.order > b?.order ? 1 : 0)} />
                    {!!(this.props.estimate?.program_notes || []).length &&
                        <NoteSection title="Notes about the PACE program"
                                     notes={this.props.estimate?.program_notes}
                                     isOpenOnMount={false}
                        />
                    }
                </div>


                {this.state.chartModalData &&
                    <BaseModal visible onClose={this.handleChartClose} cardStyle={{width: '60vw'}}>
                        <div style={{height: '30vw', minHeight:'350px', width: '100%'}}>
                            <PPAChart data={this.state.chartModalData}/>
                        </div>
                    </BaseModal>
                }

            </div>
        )
    }
}


const mapStateToProps = state => ({
    is_admin: state.user.decodedTokenData?.admin
})

export default connect(mapStateToProps)(LoanEstimateCard);